// extracted by mini-css-extract-plugin
var _1 = "Expandable__content--O0q4U";
var _2 = "Expandable__dropdown--BFmre";
var _3 = "Expandable__dropdownNoPointer--PqFgf Expandable__dropdown--BFmre";
var _4 = "Expandable__icon--vzWAM";
var _5 = "Expandable__lSpacing--PUc2u";
var _6 = "Expandable__main--UjSIM";
var _7 = "Expandable__title--Uqe8O";
export { _1 as "content", _2 as "dropdown", _3 as "dropdownNoPointer", _4 as "icon", _5 as "lSpacing", _6 as "main", _7 as "title" }
